import { StyleSheet } from 'react-native';
import LottieView from '../LottieView';

export function ListeningBars() {
  return (
    <LottieView
      style={styles.bars}
      hardwareAccelerationAndroid
      autoPlay
      loop
      resizeMode="cover"
      source={require('./loading-bars-animation.json')}
    />
  );
}

const styles = StyleSheet.create({
  bars: {
    width: 80,
  },
});
